import * as KatalMetrics from '@amzn/katal-metrics';
import { createMetricsPublisher } from '@amzn/katal-metrics-mons';
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';
import { ClientLog } from 'src/constants/clientLog';
import Logger from 'src/utils/logger';

export const metricsConsoleErrorHandler = (err: Error) => Logger.error(ClientLog.MetricsFailure, err, {});

const createTestMetricsDriver = (): KatalMetrics.MetricsDriver => {
  // Note that if we are in production or SERVER_MODE 'mons' we auto-configure before running this function.
  // So for Mons apps these configurations are just for unit tests and local server tests.
  if (process.env.NODE_ENV === 'test') {
    const metricsDriver = new KatalMetricsDriverArrayCollector();
    //  Attach to global window object so tests can see it
    (window as any).metricsDriver = metricsDriver;
    return metricsDriver;
  }
  return new KatalMetricsDriverConsoleLogJson();
};

// Creating a separate metrics publisher with 'prod' domain to publish pageView metrics.
const createTestMetricsPublisher = (): KatalMetrics.Publisher => {
  const metricsDriver = createTestMetricsDriver();
  const initialMetricsContext = new KatalMetrics.Context.Builder()
    .withSite('SellerCentral')
    .withServiceName('SellerUniversity')
    .build();
  return new KatalMetrics.Publisher(
    metricsDriver,
    metricsConsoleErrorHandler,
    initialMetricsContext,
  );
};

export const createPublisher = (): KatalMetrics.Publisher => {
  if (process.env.NODE_ENV === 'production' || SERVER_MODE === 'mons') {
    return createMetricsPublisher(); // Initializes with Sushi Driver
  }
  // Otherwise we are running a test server outside of Mons so cannot use KatalMetricsMons to auto-configure.
  return createTestMetricsPublisher();
};

const katalMetricsPublisher: KatalMetrics.Publisher = createPublisher();

// Returns this singleton of Katal Metrics Publisher wherever imported and invoked
export default katalMetricsPublisher;
